module.exports = __webpack_public_path__ + "media/images/Luisa-crypto-99ab4adf84db286ccd75ef29cf21c550.png";